<template>
  <app-data-editor
    :id="id"
    title="Редактирование Повижного состава"
    resource="rolling-stock-types"
    :elements="elements"
    add-message="Подвижной состав добавлен"
    edit-message="Подвижной состав изменен"
    @change="(payload) => isChanged = payload"
  />
</template>

<script>
import mixin from "./../../mixins/confirm-cancel-changes.js";
export default {
  mixins: [mixin],
  props: ["id"],
  data() {
    return {
      elements: [
        [
          {
            title: "Наименование",
            name: "title",
            control: {
              type: "title-text",
              required: true,
              rules: [
                (v) => !!v || "Наименование обязательно к заполнению",
                (v) =>
                  v.length >= 3 ||
                  "Наименование должно содержать не менее 3-х символов",
              ],
            },
            default: "",
          },
          {
            title: "Тип транспорта",
            name: "type",
            control: {
              type: "enum",
              resource: "transport-types",
              required: true,
              clearable: false,
            },
          },
        ],
      ],
    };
  },
};
</script>
